/*
 @author       Holger Schauf
 @title        Toggle Behavior
 @type         helper
 @description  set sticky behavior events on target and trigger

 @example      var sticky = new mote.Toggle(); dropdown.show();
 @example      mote.run('Toggle').show();
 */

var mote = typeof mote !== 'undefined' ? mote : {};

mote.Toggle = (function ($) {
    return Class.extend({
        visible: false,
        pinned: false,

        init: function (cfg) {
            // set config
            this.cfg = Object.assign(
                {
                    active: 'active',
                    target: null,
                    trigger: null,
                    hovered: false,
                    pinned: true,
                    onShow: function () {},
                },
                cfg
            );

            // disable hover if touch device
            if (this.cfg.hovered) {
                this.cfg.hovered = !mote.isTouch();
            }

            this.events();
        },

        events: function () {
            if (this.cfg.hovered) {
                this.cfg.trigger.on(
                    'mouseenter.toggle',
                    mote.doLater(this.show, this)
                );
                this.cfg.trigger
                    .parent()
                    .on('mouseleave.toggle', mote.doLater(this.hide, this));
            }

            if (this.cfg.pinned) {
                this.cfg.trigger.on(
                    'click.toggle',
                    mote.doLater(this.toggle, this)
                );
                this.cfg.target.on(
                    'click.toggle',
                    mote.doLater(this.setPinned, this)
                );
            }
        },

        /**
         *
         * @param e
         * @returns {boolean}
         */
        toggle: function (e) {
            e.preventDefault();

            if (this.cfg.hovered) {
                // event delay workaround
                if (this.cfg.pinned) {
                    this.setOuterEvent();
                }

                this.pinned = !this.pinned;
                return false;
            }

            this.visible ? this.hide() : this.showToggle();

            return false;
        },

        /**
         *
         * @returns {boolean}
         */
        show: function () {
            this.cfg.target.show();

            this.cfg.trigger.addClass(this.cfg.active);

            if (!this.visible) {
                this.cfg.onShow();
            }

            this.visible = true;

            return this.visible;
        },

        /**
         *
         * @returns {boolean}
         */
        showToggle: function () {
            if (this.cfg.pinned) {
                this.setPinned();
            }

            this.pinned = true;
            return this.show();
        },

        /**
         *
         * @returns {boolean}
         */
        setOuterEvent: function () {
            this.cfg.target
                .off('outerclick')
                .on('outerclick', mote.doLater(this.checkHide, this));

            return true;
        },

        /**
         *
         * @returns {boolean}
         */
        hide: function () {
            if (this.pinned && this.cfg.hovered) {
                return false;
            }
            this.cfg.target.hide();

            this.cfg.trigger.removeClass(this.cfg.active);

            if (this.cfg.pinned) {
                this.cfg.target.off('outerclick');
            }

            this.visible = false;
            this.pinned = false;

            return this.visible;
        },

        /**
         *
         * @returns {boolean}
         */
        checkHide: function () {
            this.pinned = false;

            return this.hide();
        },

        /**
         *
         * @returns {boolean}
         */
        setPinned: function () {
            this.setOuterEvent();
            this.pinned = true;
            return this.pinned;
        },

        /**
         * remove events
         */
        remove: function () {
            this.cfg.trigger.off('click.toggle');
            return this.hide();
        },
    });
})(jQuery);
